import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import useFetchUsers from '../../hooks/fetchUsers';
import { Pagination, Input, Row, Col, Select, Form, DatePicker } from 'antd';
import { CSVLink } from 'react-csv';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit';
import { dateConverter } from '../../utils/utcDateConversion';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

function RecurringDetailsRecord() {
  const user = JSON.parse(localStorage.getItem('user'));
  const donorIdforRecurring = localStorage.getItem('donorIdforRecurring');
  const { t } = useTranslation(['common']);
  let { Search } = Input;
  let navigate = useNavigate();

  let users;
  let searchedUser;
  function goBack() {
    if (user.userType === 'A') navigate('/reports/recurring', { replace: true });
    else if (user.userType === 'O') navigate('/orgreport/donors', { replace: true });
  }
  window.addEventListener('popstate', goBack);
  const [editbtn, setEditBtn] = useState('none');
  const [reportObj, setReportObj] = useState({});
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [fetchUsers, setFetchUsers] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [searchShow, setSearchShow] = useState(false);
  const [renderList, setRenderList] = useState();
  const [tableShow, setTableShow] = useState(true);
  const [basicModal, setBasicModal] = useState(false);
  const [currRecurr,setCurrRecurr] = useState({});
  const [err, setErr] = useState('');
  const u = useFetchUsers();
  console.log(u);
  let recurringObj=JSON.parse(localStorage.getItem('recurringObj'))
  console.log(recurringObj);
  let payloadObj={};
  if(recurringObj)payloadObj={
    // organizationId:299,
    // contractId:"10000000022044",
  organizationId:recurringObj.organizationId,
  contractId:recurringObj.mxRecurrContractId,
   limit:"1000",
   offset:"0"
   
  }
  const token=getTokenfromUserObj();
  const toggleShow = (val) =>{
    console.log("val")
    console.log(val)
    setCurrRecurr(val)
    setBasicModal(!basicModal);} 
  const userCount = u.response ? u.response.data.length : 0;
  console.log(userCount);
  console.log(window.location.pathname);
  // let newStartDate;
  // let newEndDate;
  // const fetchData = async (obj) => {
  //   console.log('fetchData');
  //   const limit = 1000;
  //   const offset = 0;
  //   obj.limit = limit;
  //   obj.offset = offset;
  //   obj.organization = user.organizationId;
  //   console.log(obj);
  //   let searchQuery;
  //   console.log(user.organizationId);
  //   if (window.location.pathname === '/orgreport/recurring' && user.userType === 'O') searchQuery = `${app.URL}/recurring/recurringreportbyorg/${user.organizationId}`;
  //   if (window.location.pathname === '/reports/donation' && user.userType === 'A') searchQuery = `${app.URL}/trans/searchtransbyorgs/${user.organizationId}`;
  //   const tr = await axios.post(searchQuery, obj);
  //   console.log(tr);
  //   let dateConv;
  //   tr.data ? (dateConv = dateConverter(tr.data.data, 'startDate')) : ' ';
  //   tr.data ? setCurrent(1) : 0;
  //   tr.data ? setFetchUsers(dateConv) : console.log(0);
  //   tr.data ? setRenderList(dateConv.slice(0, 10)) || setPagesCount(tr.data.data.length) : [];
  // };

  useEffect(() => {
    const userList = async () => {
      console.log('user list function called');
      const donorId = JSON.parse(localStorage.getItem('donorId'));
      const limit = 1000;
      const offset = 0;
      let convertedObj;
      let fetchQuery;
      if (user.userType === 'O' && window.location.pathname === '/orgreport/recurring') fetchQuery = `${app.URL}/recurring/viewbyorg?orgId=${user.organizationId}&donorId=${donorId}`;
      if (user.userType === 'A' && window.location.pathname === '/reports/recurrdetails') fetchQuery = `${app.URL}/merchantportal/contractpaymentrecords`;
      console.log(fetchQuery);
      const recurrAPIResp = await axios.post(fetchQuery, payloadObj,{headers:{auth:token}});
      console.log(recurrAPIResp);
      let dateConv;
  
      recurrAPIResp.data ? (dateConv = dateConverter(recurrAPIResp.data.data.records, 'created')) : ' ';
      recurrAPIResp.data ? (dateConv = dateConverter(dateConv, 'settledDate')) : ' ';
      recurrAPIResp.data?setRenderList(dateConv):" ";
      // userResp.data ? setRenderList(convertedObj.slice(0, 10)) : ' ';
    };
    userList();
  }, [window.location.pathname]);

  const onChange = async (page, pageSize) => {
    console.log(page);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    setRenderList(fetchUsers.slice(reqObj.offset, reqObj.offset + limit));
    // if(users){
    //   console.log("users")
    //   setRenderList(users)
    // }
    console.log(renderList);
  };

  console.log(renderList);



  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
      <div className='row mt-2'>
        <div className='col-lg-12 col-md-10 col-sm-10 fs-3 fw-bold'>{t('Recurring Details')}</div>
      </div>
      {renderList&&renderList.length>0?<>
      <div className='col-lg-12 col-md-12 col-sm-12 '>
        <div class=' styled-table '>
       <table class='table text-black'>
            <thead class='thead-light'>
              <tr>
                {/* <th>{t("ID")}</th> */}
                <th style={{ width: '100px' }}>{t('Reference ID')}</th>
                <th style={{ width: '100px' }}>{t('customerName')}</th>
                <th style={{ width: '100px' }}>{t('Card Type')}</th>
                <th style={{ width: '100px' }}>{t('Last 4')}</th>
                <th style={{ width: '100px' }}>{t('Created On')}</th>
               <th>{t('Amount')}</th>
                <th>{t('Settled Amount')}</th>
                <th>{t('Settled Date')}</th>
                <th>{t('Status')}</th>
                {/* <th>{t('Frequency')}</th>
                <th>{t('Start Date')}</th>
                <th>{t('Occurrences')}</th> */}
               
                {/* {user.userType==="A"?<th>{t("Organization")}</th>:""}  */}
              </tr>
            </thead>
           <tbody>
              {renderList ? renderList.map((output) => (
                    // onClick={()=>{editUser(output)}}
                    <tr className='row-hover'>
                      {/* <td >{output.userId}</td> */}
                      {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                      <td style={{ width: '50px' }}>{output.reference}</td>
                      <td style={{ width: '50px' }}>{output.customerName}</td>
                      <td style={{ width: '50px' }}>{output.cardAccount.cardType}</td>
                      <td style={{ width: '50px' }}>{output.cardAccount.last4}</td>
                      {/* <td style={{ width: '50px' }}>{output.customerName}</td> */}
                      {user.userType==="A"?<td style={{ width: '160px' }}>{output.created}</td>:" "}
                      <td style={{ width: '50px' }}>{output.amount} {output.currency}</td>
                      <td style={{ width: '80px' }}>{output.settledAmount}</td>
                      <td style={{ width: '130px' }}>{output.settledDate}</td>
                      <td style={{ width: '130px' }}>{output.status}</td>
                     
                      {/* <td style={{ width: '40px' }}>
                      <button onClick={()=>toggleShow(output)} className='btn button btn-primary recurr-btn '>Detail</button>
                      </td>    */}
                    </tr>
                  ))
                : " "}
            </tbody>  
            
          </table>
        </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={10} total={pagesCount} /></>
      :<div class="no-record">
      <p>No record found</p>
    </div>}



      <MDBModal show={basicModal} setShow={setBasicModal} tabIndex='-1'>
<MDBModalDialog>
  <MDBModalContent>
    <MDBModalHeader>
      <MDBModalTitle>Contract ID: {currRecurr.mxRecurrContractId}</MDBModalTitle>
      <MDBBtn className='btn-close' color='none' onClick={toggleShow}></MDBBtn>
    </MDBModalHeader>
    <MDBModalBody>
    <form>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row '>
        <div className='col-lg-4 mt-1'>Organization </div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={currRecurr.organizationName}/></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row'>
        <div className='col-lg-4 mt-1'>Donor </div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={`${currRecurr.firstName} ${currRecurr.lastName}`}/></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row'>
        <div className='col-lg-4 mt-1'>Cause</div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={currRecurr.cause}/></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row'>
        <div className='col-lg-4 mt-1'>Donation</div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={`$ ${currRecurr.amount}`}/></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row'>
        <div className='col-lg-4 mt-1'>Frequency</div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={currRecurr.paymentInterval}/></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row'>
        <div className='col-lg-4 mt-1'>Start Date</div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={currRecurr.startDate}/></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row'>
        <div className='col-lg-4 mt-1'>Occurrences</div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Unlimited" value={currRecurr.occurrences}/></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row '>
      {/* `${currRecurr.dayType}` */}
        <div className='col-lg-4 mt-1'>{currRecurr.paymentInterval==="Yearly"?"On Every":"On Every"}</div>
        <div className='col-lg-4'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={currRecurr.paymentInterval==="Yearly"?`${currRecurr.startDate.slice(3,6)}`:currRecurr.paymentInterval==="Weekly"?`${currRecurr.paymentDay}`:`${currRecurr.dayType}`}/></div>
        {/* <div className='col-lg-3 mt-1'>Day Number</div> */}
        <div className='col-lg-3'><input type="text" id="disabledTextInput" class="form-control pl-9 " placeholder="Disabled input" value={currRecurr.dayNumber}/></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row'>
        <div className='col-lg-4 mt-1'>Status</div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={currRecurr.isActive}/></div>
        {/* <div className='col-lg-7'>{currRecurr.isActive==="Active"?<CheckCircleFilled style={{color:"#0a466b", fontSize:"25px"}}/>:<CloseCircleFilled style={{color:"red", fontSize:"25px"}}/>}</div> */}
      </div>
    </div>
    </fieldset>
    </form>
    </MDBModalBody>

    <MDBModalFooter>
    <button className='btn button btn-primary' color='secondary'>
        Cancel Contract
      </button>
      <button className='btn button btn-primary' color='secondary' onClick={toggleShow}>
        Close
      </button>
      {/* <MDBBtn>Save changes</MDBBtn> */}
    </MDBModalFooter>
  </MDBModalContent>
</MDBModalDialog>
</MDBModal>
    </div>


    //     </div>
    //   </div>
    // </div>
  );
}

export default RecurringDetailsRecord;
